import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import { PerplayLogApi, LogControllerDtoBreedLogListRequest } from '../../models/src';
import {
  breedLogList,
  setBreedLogPagination,
  setTotalCount
} from '../../actions/log/breedLogActions';
import { BREEDLOG_LIST_REQUEST } from '../../constants/log/breedLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoBreedLogListResponse from '../../models/src/model/LogControllerDtoBreedLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* breedLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoBreedLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.breedType = payload.breedType;
    requestData.account = payload.account;
    requestData.nftUid = payload.nftUid;
    requestData.parentNftUid = payload.parentNftUid;
    console.log('requestData: ', requestData);

    const result = yield api.apiPerplayLogBreedLogListPost({ logControllerDtoBreedLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoBreedLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    yield put(breedLogList(data.list));
    yield put(setTotalCount(data.totalCount));
    yield put(setBreedLogPagination(
      payload.page,
      data.totalCount,
      payload.beginDate,
      payload.endDate,
      payload.searchCode,
      payload.searchString,
    ));
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* breedLogRootSaga() {
  yield all([
    takeEvery(BREEDLOG_LIST_REQUEST, breedLogListRequestSaga),
  ])
}

const breedLogSagas = [
  fork(breedLogRootSaga),
];

export default breedLogSagas;
